!(function (window, document, undefined) {
    'use strict';

    function toogleTracking ($this) {
        const value = $this.attr('data-eventlabel');

        const isOpen = $this.parents('.detail-title.opened').length;
        if (isOpen == 0) {
            gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[${value}]`, 'event_label': `[${value}]` });
            $this.removeClass(value).addClass(value + '-fechar');
        } else {
            gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[${value}]`, 'event_label': `[${value}-fechar]` });
            $this.removeClass(value + '-fechar').addClass(value);
        }
    }

    $.scrollDepth({
        userTiming: false,
        pixelDepth: false,
        nonInteraction: false,
        gtmOverride: true,
    });

    const trackEvent = (selector, event, trackCategory, tracAction, trackLabel) => {
        $(selector).on(event, function () {
            gtag('event', event, { 'event_category': trackCategory, 'event_action': tracAction, 'event_label': trackLabel });
        });
    };

    trackEvent('lp-perdigao-core:body:desktop', 'body:srcoll:scroll', 'scroll');

    trackEvent('[data-component="hero"] .btn-video', 'click', 'lp-perdigao-core:video:desktop', 'video:clicou:[clique-play]', '[clique-play]');
    trackEvent('[data-component="hero"] .btn-close', 'click', 'lp-perdigao-core:video:desktop', 'video:clicou:[clique-play-fechar]', '[clique-play-fechar]');

    trackEvent('[data-component="header"] [href="campanha/"]', 'click', 'lp-perdigao-core:header:desktop', 'header:clicou:[campanha]', '[campanha]');
    trackEvent('[data-component="header"] [href="produtos/"]', 'click', 'lp-perdigao-core:header:desktop', 'header:clicou:[produtos]', '[produtos]');
    trackEvent('[data-component="header"] [href="receitas/"]', 'click', 'lp-perdigao-core:header:desktop', 'header:clicou:[receitas]', '[receitas]');

    trackEvent('[data-component="footer"] .svg-instagram', 'click', 'lp-perdigao-core:footer:desktop', 'footer:clicou:[instagram]', '[instagram]');
    trackEvent('[data-component="footer"] .svg-facebook', 'click', 'lp-perdigao-core:footer:desktop', 'footer:clicou:[facebook]', '[facebook]');
    trackEvent('[data-component="footer"] .svg-youtube', 'click', 'lp-perdigao-core:footer:desktop', 'footer:clicou:[youtube]', '[youtube]');
    trackEvent('[data-component="footer"] .svg-twitter', 'click', 'lp-perdigao-core:footer:desktop', 'footer:clicou:[twitter]', '[twitter]');


    $('form select').on('change', function () {
        const value = $(this).val();
        gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[${value}]`, 'event_label': `[${value}]` });
    });

    $('[data-component="products"] .btn-prepare').on('click', function () {
        toogleTracking($(this));
    });

    $('[data-component="products"] .btn-ingredients').on('click', function () {
        toogleTracking($(this));
    });

    $('[data-component="products"] .btn-nutritional').on('click', function () {
        toogleTracking($(this));
    });

    $('[data-component="recipes"] a.recipe-item').on('click', function () {
        const value = $(this).attr('data-eventlabel');
        gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[${value}]`, 'event_label': `[${value}]` });
    });

    $('[data-component="recipes"] article.recipe-item-modal .btn-close').on('click', function () {
        const value = $(this).parents('[data-eventlabel]').attr('data-eventlabel');
        gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[${value}-fechar]`, 'event_label': `[${value}-fechar]` });
    });

    $('.slider-content').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        const value = $(this).find(`[data-slick-index="${nextSlide}"]`).attr('data-eventlabel');
        gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[${value}]`, 'event_label': `[${value}]` });
    });

    $('.slider-photo-content').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        const value = $(this).find(`[data-slick-index="${nextSlide}"]`).attr('data-eventlabel');
        gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[${value}]`, 'event_label': `[${value}]` });
    });

    $document.on('click', '.slider-thumb .slick-next', function() {
        const $sliderContent = $(this).parents('[data-component="product-item"]').find('.slider-content');
        const curerntSlide   = $sliderContent.slick('slickCurrentSlide');
        const value          = $sliderContent.find(`[data-slick-index="${curerntSlide}"]`).attr('data-eventlabel');

        gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[seta-${value}]`, 'event_label': `[seta-${value}]` });
    });

    $('.slider-thumb').on('change', function() {
        console.log('oi');
    });

    $document.on('click', '.slider-thumb .slick-prev', function() {
        const $sliderContent = $(this).parents('[data-component="product-item"]').find('.slider-content');
        const curerntSlide   = $sliderContent.slick('slickCurrentSlide');
        const value          = $sliderContent.find(`[data-slick-index="${curerntSlide}"]`).attr('data-eventlabel');

        gtag('event', 'click', { 'event_category': 'lp-perdigao-core:body:desktop', 'event_action': `body:clicou:[seta-${value}]`, 'event_label': `[seta-${value}]` });
    });

})(window, document, undefined);
